import { BookOutlined } from "@ant-design/icons";

const LibbyIcon = () => {
  return <BookOutlined />;
};

export default LibbyIcon;
